export default __webpack_public_path__ + "media/zurb/img/party/lg-da6d3281f58c419fa514ab51f9e86d0c.png";